
export class User{
    id: number;
    name: string;
    role_id: number;
    email: string;
    filenameCenter: string;
    center_enableWorkPermit: number;
    center_enableTask: number;
    center_enableTimeControl: number;

    constructor(id, name, role_id, email, filenameCenter, center_enableWorkPermit, center_enableTask, center_enableTimeControl){
        this.id = id;
        this.name = name;
        this.role_id = role_id;
        this.email = email;
        this.filenameCenter = filenameCenter;
        this.center_enableWorkPermit = center_enableWorkPermit;
        this.center_enableTask = center_enableTask;
        this.center_enableTimeControl = center_enableTimeControl;
    }
}
